var React = require('react');

function LogoFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.324 0.000976562C0.593 0.000976562 0 0.59394 0 1.3249V22.6756C0 23.4075 0.593 23.9995 1.324 23.9995H13V15.0001H10V12.0002H13V10.0004C13 6.90156 15.235 5.00067 18 5.00067C19.325 5.00067 20.168 4.95667 20.5 5.00067L20 8.00049H18C16.5 8.00049 16 8.95043 16 10.0004V12.0002H20.273L19.5 15.0001H16V23.9995H22.675C23.408 23.9995 24 23.4075 24 22.6756V1.3249C24 0.59394 23.408 0.000976562 22.676 0.000976562H1.324Z","fill":"currentColor"}));
}

LogoFacebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LogoFacebook;

LogoFacebook.default = LogoFacebook;
